/**
 * In sviluppo permette di reindirizzare alcune chiamate al dev server locale
 * invece che all'`apiBaseUrl` configurato. La lista degli endpoint da
 * reindirizzare è passata tramite la variabile d'ambiente
 * `LOCAL_API_ENDPOINTS` (separati da virgola).
 *
 * Ritorna il `baseURL` da usare per la richiesta, oppure `undefined` se non
 * deve essere applicato alcun override.
 */
export function getLocalApiBaseUrlOverride(
  url: string | undefined,
): string | undefined {
  if (process.env.NODE_ENV !== 'development') return undefined;
  if (!url) return undefined;

  const endpoints = process.env.LOCAL_API_ENDPOINTS?.split(',') ?? [];
  const matches = endpoints.some(endpoint => url.startsWith(endpoint));

  return matches ? '/' : undefined;
}
